import { useNavigate } from 'react-router';
import type { SubjectKind } from '@hp/domain';
import { usePendingClusterIds } from './queries';

/** j/k neighbors over the pending queue (id desc). */
export function useQueueNav(entityType: SubjectKind, clusterId: number) {
  const navigate = useNavigate();
  const pendingIds = usePendingClusterIds(entityType);

  function neighborId(direction: 1 | -1): number | null {
    const ids = pendingIds.data;
    if (!ids || ids.length === 0) return null;
    const idx = ids.indexOf(clusterId);
    if (idx !== -1) {
      const next = ids[idx + direction];
      return next ?? null;
    }
    // current cluster not in the pending list (e.g. just decided) — find by id order
    if (direction === 1) return ids.find((id) => id < clusterId) ?? null;
    return [...ids].reverse().find((id) => id > clusterId) ?? null;
  }

  function goTo(direction: 1 | -1) {
    const target = neighborId(direction);
    if (target !== null) void navigate(`/crm-data/deduplication/${target}`);
    else if (direction === 1) void navigate('/crm-data/deduplication');
  }

  return { neighborId, goTo };
}
